import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
// import TextField from "@material-ui/core/TextField";
import LocationAutoComplete from "./LocationAutoComplete";
import EditSponsorElement from "../EditSponsorElement";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import InfoIcon from "@material-ui/icons/Info";
import { Tooltip } from "@material-ui/core";

export default class EditSportParkDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {this.props.sportPark
            ? languages.schedule.editSportPark
            : languages.schedule.addSportPark}
        </DialogTitle>
        <form>
          <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText />
            {/* <TextField
              autoFocus
              margin="dense"
              label={languages.general.name}
              value={this.props.name}
              name="name"
              onChange={this.props.handleChange}
              type="text"
              fullWidth
            /> */}
            <LocationAutoComplete
              label={languages.createTournament.location}
              value={this.props.name}
              handleChange={this.props.handleChange}
              setName={this.props.setName}
            />

            {!this.props.new && (
              <div style={{ marginTop: 20 }}>
                <FormGroup style={{ marginTop: 5 }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.props.showSponsor}
                        onChange={this.props.handleShowSponsorChange}
                        color="primary"
                        name="showSponsor"
                      />
                    }
                    label={languages.general.locationLogo}
                  />
                  {this.props.showSponsor && (
                    <div>
                      {this.props.allowedToUpload ? (
                        <EditSponsorElement
                          tournament={this.props.tournament}
                          sponsorName={this.props.sponsorName}
                          sponsorLogoURL={this.props.sponsorLogoURL}
                          sponsorStorageRef={this.props.sponsorStorageRef}
                          handleDeleteSponsor={this.props.handleDeleteSponsor}
                          handleUploadStart={this.props.handleUploadStart}
                          handleProgress={this.props.handleProgress}
                          handleUploadError={this.props.handleUploadError}
                          handleUploadSuccess={this.props.handleUploadSuccess}
                          allowedToUpload={this.props.allowedToUpload}
                          handleSponsorNameChange={
                            this.props.handleSponsorNameChange
                          }
                          errorMessage={this.props.errorMessageSponsor}
                          isUploading={this.props.isUploadingSponsor}
                        />
                      ) : (
                        <div
                          style={{
                            background: "rgb(236, 239, 241)",
                            padding: 10,
                            borderRadius: 5,
                          }}
                        >
                          <InfoIcon
                            style={{
                              height: 15,
                              width: 15,
                              top: 2,
                              position: "relative",
                            }}
                          />
                          {" " + languages.upgrade.upgradeTextExtraSponsor}
                          <br />
                          <Button
                            style={{ marginTop: 5 }}
                            variant="contained"
                            onClick={this.props.toggleUpgradeDialog}
                            color="primary"
                            size="small"
                          >
                            {languages.upgrade.seePackages}
                          </Button>
                        </div>
                      )}
                    </div>
                  )}
                </FormGroup>
              </div>
            )}

            {(this.props.errorMessage || "").length > 0 && (
              <DialogContentText style={{ color: "red" }}>
                {this.props.errorMessage}
              </DialogContentText>
            )}
          </DialogContent>

          <DialogActions>
            {this.props.sportPark && this.props.sportPark.id === "0" ? (
              <Tooltip
                disableFocusListener
                title={languages.structure.firstLocationTooltip}
              >
                <div>
                  <Button onClick={this.props.handleDelete} disabled>
                    {languages.general.delete}
                  </Button>
                </div>
              </Tooltip>
            ) : (
              this.props.sportPark && (
                <Button onClick={this.props.handleDelete} color="secondary">
                  {languages.general.delete}
                </Button>
              )
            )}
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.props.handleSubmit}
              variant="contained"
              color="primary"
              type="submit"
            >
              {this.props.sportPark
                ? languages.general.save
                : languages.general.add}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
